const SERVER_FIELDS = new Set(['_id', '__v', 'createdAt', 'updatedAt', 'createdBy', 'createdByName',
  'updatedBy', 'updatedByName', 'currentStatus', 'currentRevision', 'revisions', 'revisionHistory',
  'releasedSnapshots', 'approval', 'availableRevisions', 'snapshot', 'expectedVersion']);

export function procedureAuthorPayload(record) {
  return Object.fromEntries(Object.entries(record || {}).filter(([key]) =>
    !SERVER_FIELDS.has(key) && !key.startsWith('$') && !key.includes('.')));
}

export function downloadText(content, filename, type = 'application/json') {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.replace(/[<>:"/\\|?*\x00-\x1f]/g, '_'); // eslint-disable-line no-control-regex
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const authorInput = { background:'var(--ni-panel)', border:'1px solid var(--ni-border-soft)',
  color:'var(--ni-text)', borderRadius:6, padding:'7px 10px', fontSize:13, width:'100%', boxSizing:'border-box' };
export const authorButton = { background:'transparent', border:'1px solid var(--ni-border-soft)',
  color:'var(--ni-text)', borderRadius:6, padding:'7px 12px', fontSize:12, cursor:'pointer' };
export const authorPanel = { background:'var(--ni-panel)', border:'1px solid var(--ni-border-soft)',
  borderRadius:10, padding:16, marginBottom:18 };

export function procedureTemplate(kind) {
  return { documentNumber:'', name:'', description:'', applicability:'',
    ...(kind === 'test' ? { testType:'Generic', passCriteria:'', samplingPlan:{ method:'100%' } } : { productFamily:'', productNumbers:[] }),
    steps:[], sourceReferences:[], releaseBlockers:[{ key:'engineering-review', description:'Confirm assembly steps, acceptance criteria and applicability before release.', resolved:false }],
    visibility:{ suppliers:[], draftSuppliers:[], supplierAccess:'None' } };
}

export function safeSourceUrl(value) {
  try { const url = new URL(value); return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null; }
  catch { return null; }
}
